var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOc100(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.83309 12.5751V18.3332L9.75216 16.7655C9.84363 16.729 9.88936 16.7107 9.93658 16.7034C9.97845 16.697 10.0211 16.697 10.0629 16.7034C10.1101 16.7107 10.1559 16.729 10.2473 16.7655L14.1664 18.3332V12.5751M16.2498 7.9165C16.2498 11.3683 13.4515 14.1665 9.99976 14.1665C6.54798 14.1665 3.74976 11.3683 3.74976 7.9165C3.74976 4.46472 6.54798 1.6665 9.99976 1.6665C13.4515 1.6665 16.2498 4.46472 16.2498 7.9165Z",
    stroke: "#141BEB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOc100);
export default __webpack_public_path__ + "static/media/oc-100.2486ae9f1999b61c9cb091d9b1074d15.svg";
export { ForwardRef as ReactComponent };